var exports = {
  "P1": "scrollArea__A4uYxY",
  "x0": "navWrapper__KtBZzH",
  "XH": "quicklinks__s4Lrh2",
  "qr": "footer__-a5Sjl",
  "tu": "blankslateContainer__igyhFI",
  "E5": "toggleButtonIcon__dvhKzn",
  "wC": "footerButton__fBmhdl",
  "He": "footerButtonContent__CADzcM",
  "U0": "condensed__eTzk4u",
  "tB": "footerButtonIcon__QVKdmi",
};

module.exports = exports;
